module.exports = {"id":"193290","name":"Martin Braithwaite","rating":"75","photo":"./data/images/photos/0/193290.png","club":{"name":"Girondins de BX","logo":"./data/images/clubs/GirondinsdeBX.png"},"positions":["MOC","BU","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MartinBraithwaite0.json
// module id = 2813
// module chunks = 0